//requires: public\pclm-map-helper.js

var markerManager={
		
		_markers_layers : {},
		_markers_idles: {},
		_eventManager: eventManager,
		_selectionStyle: {color: "#ff7800", weight: 1},
		
		
		init: function(){
			
			var mapsHtmlId = mapsManager.searchMapOnPage(mapsManager.get_map_id_prefix());
			
			this._behaviours = new L.Behaviours();
			
			mapsHtmlId.each(function() {
				
				var map = mapsManager.getMapElt(this.id);
				if (map){map.on('zoomend', markerManager.onZoomChange);}
				
				jQuery.get({
					url:pclm_ajax_object.ajaxurl,
					data:{	
						"nonce": pclm_ajax_object.nonce_markers_data,
						"action":"markers_data",
						"id": this.id 
					},
					context: markerManager,
					dataType: 'json',
					success:	function(data){
						
						
						// For every marker got from db
						for (var markersIdx in data.markers){
							
							var leafletData = JSON.parse(data.markers[markersIdx]['leaflet_data']);
							var leafletDataProperties =  leafletData['properties'];
							var leafletDataOptions =  leafletData['options'];
							
							
							var icon = markerManager.icon.create(leafletDataOptions);
													
							var marker = L.marker(leafletDataProperties['position'],leafletDataOptions);
							
							if (icon!= false){
								marker.setIcon(icon);
							}

							var postData = data.markers[markersIdx]['post'];
							
							marker.publication.setPostId(postData['ID']);
							marker.publication.setParent(postData['post_parent']);
							marker.publication.setStatut(postData['post_status']);
							marker.publication.setDate(postData['post_date']);
							marker.publication.setDateGMT(postData['post_date_gmt']);
							//marker.publication.setVisibility(postData['post_visibility']);
							marker.publication.setPassword(postData['post_password']);
							
							if (data.markers[markersIdx]['behaviours']){
								var behavioursData = JSON.parse(data.markers[markersIdx]['behaviours']);
								markerManager._behaviours.setBehaviours(marker,behavioursData);
							}
							
							markerManager.addToFeaturesGroup(marker);
							
							var parentMap = mapsManager.getMapElt(marker.publication.getParent());
							var parentMapId = mapsManager.getMapHtmlId(marker.publication.getParent());
							
							data.markers[markersIdx]['groups'] = data.markers[markersIdx]['groups'] || JSON.stringify(["0"]); 
							var markerGroups = JSON.parse(data.markers[markersIdx]['groups']);
							if (markerGroups.length == 0){markerGroups.push("0");}
							
							var markerMinZoom = marker.getMinZoom();
							var markerMaxZoom = marker.getMaxZoom();
							var mapZoom = parentMap.getZoom();
							
							if (markerMinZoom <= mapZoom && markerMaxZoom >= mapZoom ){
								tileLayersManager.addToGroups(parentMapId, markerGroups , marker);
							}else{
								var layerData = {'layer': marker, 'groups': markerGroups};
								markerManager._markers_idles[parentMapId].push(layerData);
							}
							
						}

					}
				});
			});
		},
		
		
		addMarker: function(mapId, marker){
			if((marker!= null) && (mapId != -1)){
				marker.publication.setParent(mapId.replace(mapsManager.get_map_id_prefix()+'-',''));
				//var enhancedContent = L.enhancedContent(L.EnhancedContent.None.TYPE);
//				enhancedContent.setModalHtmlId('#marker-info-'+ mapsManager.getMapHtmlId(marker.publication.getParent()));
				//marker.bindEnhancedContent(enhancedContent);
				
				this._behaviours.setBehaviours(marker,{'onClick':{type: "none",'options':{}},'onOver':{type: "none",'options':{}}});
				markerManager.addToFeaturesGroup(marker);
				
				tileLayersManager.addToGroup(mapId,"0",marker);
			}
		},
		
		removeMarker: function(mapId,marker){
			markerManager.removeFromFeaturesGroup(marker);
			tileLayersManager.removeFromAllGroups(mapId,marker);
		},
		
		updateMarker: function(marker, options){
			
			var icon = markerManager.icon.create(options);
			
			var newMarker = L.marker(marker.getLatLng(),options);
			newMarker.bindPublication(marker.publication);
			if(icon!=false){
				newMarker.setIcon(icon);
			}
			markerManager.updateFeatureGroup(marker,newMarker);
			this._behaviours.setBehaviours(newMarker, this._behaviours.getBehaviours(marker));
			
			return newMarker;
		},
		
		initFeatureGroup:function(parentId){
			if (L.markerClusterGroup && !mapsManager.checkDrawCapabilities(parentId)){
				markerManager._markers_layers[parentId] = new L.markerClusterGroup();
			}else{
				markerManager._markers_layers[parentId] = new L.FeatureGroup();
			}
			markerManager._markers_idles[parentId] = [];
			
			// Avec le système de groupes de marqueurs on ajoute plus le featuregroup global à la carte
			//var returnedLayer  = mapsManager.setLayer(parentId,markerManager._markers_layers[parentId]);
		},
		
		getFeaturesGroup: function(mapId){
			
			var mapId = mapId || null;
			// if no mapId return all markers
			if (mapId==null){
				return markerManager._markers_layers;
			}else{
				var mapHtmlId = mapsManager.getMapHtmlId(mapId);
				// if mapId return the corresponding markers group
				if (!markerManager._markers_layers[mapHtmlId]){
					//init group if don't exist
					markerManager.initFeatureGroup(mapHtmlId);
					return markerManager._markers_layers[mapHtmlId];
				}else{
					return markerManager._markers_layers[mapHtmlId];
				}
				
			}
		},
		
		addToFeaturesGroup: function(layer){
			layer.isDisplayAllowed= function(){return true};
			markerManager.getFeaturesGroup(layer.publication.getParent()).addLayer(layer);
		},
		
		removeFromFeaturesGroup: function(layer){
			layer.isDisplayAllowed= function(){return true};
			markerManager.getFeaturesGroup(layer.publication.getParent()).removeLayer(layer);
		},		
		
		updateFeatureGroup: function(oldLayer,newLayer){

			
			markerManager.getFeaturesGroup(oldLayer.publication.getParent()).removeLayer(oldLayer);
			markerManager.addToFeaturesGroup(newLayer);
			
			tileLayersManager.updateInGroups(oldLayer.publication.getParent(),oldLayer,newLayer );

		},
		
		setDrawMode: function(mapId){
			var featureGroup = markerManager.getFeaturesGroup(mapId);
			featureGroup.eachLayer(function(layer){
				markerManager.setLayerDrawMode(layer);
			});
		},
		
		unsetDrawMode: function(mapId){
			var featureGroup = markerManager.getFeaturesGroup(mapId);
			featureGroup.eachLayer(function(layer){
				markerManager.unsetLayerDrawMode(layer);
			});
		},
		
		setLayerDrawMode: function(layer){
			markerManager.manageSuspendOpening(layer, true);
		},
		
		unsetLayerDrawMode: function(layer){
			markerManager.manageSuspendOpening(layer,false);
		},
		
		manageSuspendOpening: function(layer, suspendStatus){
			layer.suspendModalOpening(suspendStatus);
			layer.suspendPopupOpening(suspendStatus);
			layer.suspendLinkOpening(suspendStatus);
		},
		
		onZoomChange: function(e){
			
			markerManager.filterMarkers(e.target._container.id, e.target.getZoom());
		},
		
		filterMarkers: function(mapId,zoomLevel){
			var toRemove = [], toAdd = [];
			var groups = tileLayersManager.getGroupsList(mapId);
			var markers = markerManager.getFeaturesGroup(mapId);
			var idles_markers = markerManager._markers_idles[mapId];
			
			/*check markers to remove*/
			for (var grpIdx in groups){
				groups[grpIdx].eachLayer(function(layer){
					if (layer.getMinZoom() > zoomLevel || layer.getMaxZoom() < zoomLevel){
						if (!toRemove.hasOwnProperty(layer)){
							toRemove.push(layer);
						}
						
					}
				})
			}
			
			/*check markers to add*/
			
			for ( var idleMkIdx in idles_markers ){
				var layerData = idles_markers[idleMkIdx];
				if (layerData.layer instanceof L.Marker){
					if (layerData.layer.getMinZoom() <= zoomLevel && layerData.layer.getMaxZoom() >= zoomLevel){
						toAdd.push(idles_markers[idleMkIdx]);
					}
				}
			};
			
			
			/*do changes*/
			for ( var toRmIdx in toRemove ){
				var layerData = tileLayersManager.removeFromAllGroups(mapId,toRemove[toRmIdx]);
				idles_markers.push(layerData);
			}
			for ( var toAddIdx in toAdd ){
				var layerData = tileLayersManager.addToGroups(mapId,toAdd[toAddIdx]['groups'],toAdd[toAddIdx]['layer'] );
				idles_markers = idles_markers.filter(
						function(elt, idx, array){
							if (this.layer && elt.layer && this.layer === elt.layer){
								return false;
							}else{
								return true;
							}
							},
							toAdd[toAddIdx]
							)

			}
			markerManager._markers_idles[mapId] = idles_markers;
			
		},

		getGroupsFromIdle: function(layer,mapId){
			var returnedGroupIdx = [];
			for ( layerIdx  in markerManager._markers_idles[mapId]){
				if (markerManager._markers_idles[mapId][layerIdx]['layer'] === layer){
					returnedGroupIdx = markerManager._markers_idles[mapId][layerIdx]['groups'];
				}
			}
			return returnedGroupIdx;
		},
		
		handleEvents : function(e){
				this.init();
		},
		
		registerForEvents : function (element){
			markerManager._eventManager.register(element);
		},
		
		icon: {
			
			_options:['iconUrl','iconRetinaUrl','iconSize','iconAnchor','popupAnchor','tooltipAnchor','shadowUrl','shadowRetinaUrl','shadowSize','shadowAnchor','className','html','bgPos'],
			
			create: function(options){
				var icon =false;
				
				var iconOptions={};
				
				for (var optionIdx in markerManager.icon._options){
					if(options.hasOwnProperty(markerManager.icon._options[optionIdx])){
						
						if ((optionIdx ==0)&&(markerManager.icon.isJsonString(options[markerManager.icon._options[optionIdx]]))){
							iconOptions[markerManager.icon._options[optionIdx]]= JSON.parse(options[markerManager.icon._options[optionIdx]]).url;
						}else{
							iconOptions[markerManager.icon._options[optionIdx]]= options[markerManager.icon._options[optionIdx]];
						}
						
						
						delete options[markerManager.icon._options[optionIdx]];
					}	
				}
				
				if (iconOptions.hasOwnProperty('iconUrl')){
					if (iconOptions.hasOwnProperty('html') || iconOptions.hasOwnProperty('bgPos')){				
						icon = L.divIcon(iconOptions);
					}else{
						icon = L.icon(iconOptions);
					}
				}
				
				return icon;
			},
		
			isJsonString: function(str) {
			    try {
			        JSON.parse(str);
			    } catch (e) {
			        return false;
			    }
			    return true;
			}
		}
		
};

jQuery(document).ready(function($){
	mapsManager.registerForEvents(markerManager);
});




L.Marker.include({

	getMinZoom: function(){
		return parseInt(this.options.minZoom);
	},

	getMaxZoom: function(){
		return parseInt(this.options.maxZoom);
	}
})

L.Marker.mergeOptions({minZoom:0,maxZoom:18})






